<div
  class="expandable-panel"
  [ngClass]="{ opened: showSettings, collapsible: collapsible, autoHeight: autoHeight }"
>
  <ng-content></ng-content>

  @if (collapsible) {
  <div
    id="expand-button"
    [style.margin-bottom.px]="bottomSpacing !== 0 ? bottomSpacing : null"
    [style.margin-top.px]="topSpacing !== 0 ? topSpacing : null"
  >
    <button
      mat-flat-button
      color="accent"
      (click)="toggleOpenState()"
      [matTooltip]="tooltip"
      style="z-index: 1000"
    >
      <mat-icon class="fa fa-caret-down" aria-label="Show panel"></mat-icon>
    </button>
  </div>
  }
</div>
